import { TableCell, TableRow, Theme, Typography, useTheme } from "@mui/material";
import { TableBodyData, TableHeaderData } from "../../types";
import { useHistory } from "react-router-dom";
import { filterType } from "../../../../redux-store/types/api-types";
import { useRoleStack } from "../../../../hooks/useRoleStack";
import { formatCurrency } from "../../../../utils/utilityFunctions";
import { useSelector } from "react-redux";
import { RootStateType } from "../../../../redux-store/reducers";

export default function HierachicalTableBody({
    tableBodyData,
    handleRoleChange
}: {
    tableBodyData: TableBodyData[],
    handleRoleChange:any,
    
}): JSX.Element {
    const theme = useTheme();
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);
    
    return (
        <>
            {tableBodyData?.map((obj: TableBodyData, i: number) => {
                return (
                    <TableRow
                        key={i}
                        sx={{
                            '& td': {
                                paddingTop: "20px",
                                paddingBottom: "15px",
                                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                                ':first-of-type': {
                                    paddingLeft: "0px",
                                }
                            },
                        }}
                    >
                        <TableCell align="left">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    fontSize: '16px',
                                    color: theme.palette.primary[500],
                                    '&:hover': {
                                        color: theme.palette.primary[500]
                                    },
                                    cursor: 'pointer'
                                })}
                                onClick={() => handleRoleChange(obj.categoryName, obj?.categoryCode)}
                            >
                                {obj?.categoryName}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    fontSize: '16px',
                                    color: theme.palette.text.primary,
                                    '&:hover': {
                                        color: theme.palette.primary[500]
                                    },
                                })}
                            >
                                {!isNaN(obj?.capitalPercent) ? obj?.capitalPercent?.toFixed(2) : 0}%
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    fontSize: '16px',
                                    color: theme.palette.text.primary,
                                })}
                            >
                                {obj?.capital < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.capital ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.capital ?? 0, locale, currencyCode })}`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    fontSize: '16px',
                                    color: theme.palette.text.primary,
                                })}
                            >
                                {obj?.netAssets < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.netAssets ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.netAssets ?? 0, locale, currencyCode })}`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    fontSize: '16px',
                                    color: obj?.unrelGainLoss < 0 ? theme.palette.error[500] : theme.palette.success[500],
                                })}
                            >
                                {obj?.unrelGainLoss < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.unrelGainLoss ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.unrelGainLoss ?? 0, locale, currencyCode })}`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    fontSize: '16px',
                                    color: theme.palette.text.primary,
                                })}
                            >
                                {!isNaN(obj?.unrelGainLossPercent) ? obj?.unrelGainLossPercent?.toFixed(2) : 0}%
                            </Typography>
                        </TableCell>
                    </TableRow>
                )
            })}
        </>
    )
}



